import {I_ACCESS_TOKEN_PARAMS,_customFetch, getFetchGETOptions} from './_base';
import LoggerService,{formatTrace} from '../../LoggerService';
import APP_CONFIG from 'config';

// ---------------------------------
// --- COLLABORATEURS
// ---------------------------------

const ENDPOINT_OOODAYS = '/ooo-days';

const logger = LoggerService.getInstance();

interface I_GET_PARAMS extends I_ACCESS_TOKEN_PARAMS {
  from?: string;
  to?: string;
}
/**
 * Requete le endpoint ooo-days
 * Récupère la liste des ooo-days
 * @param param0
 */
const get = async ({accessToken,from,to}:I_GET_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - ooodays - get...'));
  const options = getFetchGETOptions({accessToken});
  const paramFrom = from !== undefined ? `from=${from}` : '';
  const paramTo = to !== undefined ? `to=${to}` : '';
  const paramsAll = from !== undefined && to !== undefined ? [paramFrom,paramTo].join('&') : [paramFrom,paramTo].join('');
  const URL = `${ENDPOINT_OOODAYS}${APP_CONFIG.ENDPOINT_SUFFIX}?${paramsAll}`;
  return _customFetch(URL,options);
};


interface I_OOODAY_PUT_PARAMS {
  accessToken: string;
  date: string;
  value?: number;
}
/**
 * Requete le endpoint ooodays PUT
 * Met à jour un oooday
 * @param param0
 * @returns
 */
const put = async ({accessToken,date,value}:I_OOODAY_PUT_PARAMS):Promise<Response> => {
  logger.trace(...formatTrace('ApiEndpoints - ooodays - put...'));
  const params = {
    method: 'PUT',
    headers: {
      'X-API-KEY': APP_CONFIG.API_KEY,
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+accessToken
    },
    body: JSON.stringify({
      ooo_days: value !== null ? value : undefined,
    })
  };
  const URL = `${ENDPOINT_OOODAYS}${APP_CONFIG.ENDPOINT_SUFFIX}/${date}`;
  return _customFetch(URL,params);
};


const ooodaysEndpoints = {
  get,
  put,
};

export default ooodaysEndpoints;
